import { store } from "@App/state";

export const showClaimNumberField = (): boolean => {
  return (
    store.getState().analytics.source === "signal_iduna" &&
    store.getState().analytics.medium !== "online-meldung"
  );
};
